
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'
import api from '@/api'
import axios from 'axios'
import config from '@/config'

import AppLogo from '@/components/app/AppLogo.vue'
import AppWordmark from '@/components/app/AppWordmark.vue'
import AppHeader from '@/components/app/AppHeader.vue'
import RegisterCTA from '@/components/app/RegisterCTA.vue'
import UiDownloadButton from '@/components/ui/inputs/UiDownloadButton.vue'
import UiFileCard from '@/components/ui/display/UiFileCard.vue'

import JSONAPIDeserializer from 'ts-jsonapi'

import {
    UiSidebarWrapper,
} from '@hubsolv/hubsolv-ui'

enum DownloadStatus {
    NONE = 'none',
    IN_PROGRESS = 'in progress',
    DONE = 'done',
}

@Component({
    components: {
        AppHeader,
        AppLogo,
        AppWordmark,
        RegisterCTA,
        UiDownloadButton,
        UiFileCard,
    },
})
export default class ViewSingleFile extends Vue {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    
    @Prop({type: String, default: null}) postcode!: string
    @Prop({type: String, default: null}) accessCode!: String
    
    ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    file: any | null = null
    downloadUrl: string | null = null
    fileExpired: boolean = false
    
    loading: boolean = false

    showRegisterModal: boolean = false
    showFailureModal: boolean = false 
    failureReason: string | null = null

    downloadStatus: DownloadStatus = DownloadStatus.NONE

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get item () {
        if (!this.file || this.fileExpired){ 
            return {
                name: 'file.txt',
                description: 'An example file',
                fileName: 'abcde-abcde-abcde-abcde',
                createdAt: '2020-01-01T12:00:50+00:00',
                updatedAt: '2020-01-01T12:00:50+00:00',
                downloadedAt: '2020-01-01T12:00:50+00:00',
                case: {
                    identifier: 1234,
                },
                creditor: {
                    name: 'HubSolv',
                },
                source: {
                    name: 'hubsolv',
                },
            }
        } else {
            return this.file
        } 
    }

    get identifier () {
        return this.postcode
    }

    get support () {
        return {
            email: config.SUPPORT.SUPPORT_EMAIL_ADDRESS,
        }
    }

    get smallView () {
        //@ts-ignore
        return this.$mq === 'sm'
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////
    
    async created () {
        this.loading = true

        if (!this.identifier || !this.accessCode){
            this.$router.replace({ name: T.CrmRoute.AUTH_ACCESS_CODE_LOGIN })
        }

        try {
            this.file = await this.getFileDetails()
        } catch ({response}) {
            console.log('Error getting file details:', response)
            if (response && response.status == 403) {
                console.log('403 Forbidden - file expired')
                this.fileExpired = true
            } else {
                this.$router.replace({ name: T.CrmRoute.AUTH_ACCESS_CODE_LOGIN, query: {status: 'notFound'} })
            }
        }
        this.loading = false
    }

    async getFileDetails () {
        console.log( 'auth' , `${this.identifier}:${this.accessCode}` )
        const response: any = await api.get('visitor/files',{
            headers: {'Authorization': 'Basic ' + btoa(`${this.identifier}:${this.accessCode}`)},
        })
        const deserializer = new JSONAPIDeserializer.Deserializer({keyForAttribute: 'camelCase'})
        const entities = deserializer.deserialize(response.data)

        return entities[0]
    }

    async getVisitorFile () {
        return await api.get(`visitor/files/${this.file.id}`,{
            headers: {'Authorization': 'Basic ' + btoa(`${this.identifier}:${this.accessCode}`)},
        })
    }

    redirectToLogin () {
        this.showRegisterModal, this.showFailureModal = false
        this.$router.replace({ name: T.CrmRoute.AUTH_ACCESS_CODE_LOGIN })
    }

    createFailureModal (reason: string) {
        this.showFailureModal = true
        this.failureReason = reason
    }
    
    ////////////////////////////////////////////////////////////////
    // event handlers
    ////////////////////////////////////////////////////////////////

    async onDownload () {
        this.downloadStatus = DownloadStatus.IN_PROGRESS
        try {
            const response = await this.getVisitorFile()
            if (response.status === 200) window.location.href = response.data.attributes.url
        } catch ({response}) {
            this.downloadStatus = DownloadStatus.NONE
            console.log( 'Error downloading file' , response )
            if (response.status === 403) {
                this.createFailureModal('The download page for this file has expired.')
            } else {
                this.createFailureModal('Something went wrong.')
            }
        }
        this.downloadStatus = DownloadStatus.DONE
    }

}
